import cx from 'classnames';
import type { CSSProperties } from 'react';

/** Shared look for the chat header's icon buttons. */
export const CHAT_ICON_BUTTON_CLASS = cx(
  'tw-flex',
  'tw-items-center',
  'tw-justify-center',
  'tw-w-32',
  'tw-h-32',
  'tw-bg-transparent',
  'hover:tw-bg-fill-primary',
  'tw-border-none',
  'tw-cursor-pointer',
  'tw-p-0',
);

// `borderRadius: 8px` and the background transition aren't in the design-system
// scale (radius jumps 6 → 10; no transition token for this exact curve), so
// they stay inline.
export const CHAT_ICON_BUTTON_STYLE: CSSProperties = {
  borderRadius: 8,
  transition: 'background 0.12s ease',
};
